import React, { useEffect, useState } from 'react';
import { whatsappAPI } from './whatsappAPI';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Activity, MessageSquare, Zap, RefreshCw } from 'lucide-react';

const ACAO_LABEL = {
  mensagem_enviada: { label: 'Mensagem enviada', color: 'bg-emerald-100 text-emerald-700', icon: MessageSquare },
  conversa_excluida: { label: 'Conversa excluída', color: 'bg-red-100 text-red-700', icon: Zap },
  qr: { label: 'QR gerado', color: 'bg-blue-100 text-blue-700', icon: Zap },
  connected: { label: 'Conectado', color: 'bg-emerald-100 text-emerald-700', icon: Zap },
  disconnected: { label: 'Desconectado', color: 'bg-orange-100 text-orange-700', icon: Zap },
  modulo_whatsapp_toggle: { label: 'Módulo ligado/desligado', color: 'bg-purple-100 text-purple-700', icon: Zap },
};

export default function LogsWA() {
  const [logs, setLogs] = useState([]);
  const [tipo, setTipo] = useState('');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await whatsappAPI.logs(tipo || undefined);
      setLogs(r.data || []);
    } catch (e) { /* noop */ } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [tipo]); // eslint-disable-line

  return (
    <div className="space-y-4" data-testid="wa-logs-page">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <Activity className="w-5 h-5 text-emerald-600" />
          <h2 className="text-lg font-semibold">Logs do WhatsApp</h2>
          <span className="text-xs text-muted-foreground">Todas as ações — envios, conexões, exclusões</span>
        </div>
        <div className="flex gap-2">
          <select
            value={tipo}
            onChange={e => setTipo(e.target.value)}
            className="border rounded px-3 py-1 text-sm"
            data-testid="select-tipo-log"
          >
            <option value="">Tudo</option>
            <option value="mensagem">Só mensagens enviadas</option>
            <option value="evento">Só eventos (conexão, exclusão)</option>
          </select>
          <Button size="sm" variant="outline" onClick={load}>
            <RefreshCw className="w-4 h-4 mr-1" />Atualizar
          </Button>
        </div>
      </div>

      <Card>
        <table className="w-full text-sm">
          <thead className="bg-muted/50">
            <tr>
              <th className="p-2 text-left w-40">Data/hora</th>
              <th className="p-2 text-left w-44">Ação</th>
              <th className="p-2 text-left w-40">Usuário</th>
              <th className="p-2 text-left">Detalhe</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={4} className="p-8 text-center text-muted-foreground">Carregando...</td></tr>}
            {!loading && logs.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-muted-foreground">Nenhum log ainda</td></tr>}
            {!loading && logs.map((l, i) => {
              const meta = ACAO_LABEL[l.acao] || { label: l.acao, color: 'bg-gray-100 text-gray-700', icon: Zap };
              const Ic = meta.icon;
              return (
                <tr key={i} className="border-t hover:bg-muted/30">
                  <td className="p-2 text-xs text-muted-foreground">
                    {l.at ? new Date(l.at).toLocaleString('pt-BR') : '-'}
                  </td>
                  <td className="p-2">
                    <span className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded ${meta.color}`}>
                      <Ic className="w-3 h-3" />{meta.label}
                    </span>
                  </td>
                  <td className="p-2 text-xs">
                    {l.por_nome ? (
                      <span className="font-medium">👤 {l.por_nome}</span>
                    ) : (
                      <span className="text-muted-foreground italic">sistema</span>
                    )}
                  </td>
                  <td className="p-2 text-xs">
                    {l.tipo === 'mensagem' ? (
                      <>
                        <span className="text-muted-foreground">para</span>{' '}
                        <span className="font-mono">{(l.detalhe?.jid || '').split('@')[0]}</span>
                        <span className="text-muted-foreground">: </span>
                        <span>&quot;{l.detalhe?.texto || ''}&quot;</span>
                      </>
                    ) : (
                      <pre className="text-[10px] whitespace-pre-wrap font-mono">{JSON.stringify(l.detalhe || {}, null, 0)}</pre>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Card>

      <p className="text-xs text-muted-foreground text-center">
        Página oculta — acessível apenas via URL direta (/whatsapp/logs)
      </p>
    </div>
  );
}
